export default function isSafeUrl(url: string) {
  const parser = document.createElement('a');
  parser.href = url;
  return (
    parser.protocol === window.location.protocol &&
    parser.host === window.location.host
  );
}
